import React from 'react'

import { AppearingWrapper, SubsectionTitle } from 'Components/Blocks'
import { Column, Text } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

function MoreThanJustGolfSectionTitle() {
  const { isMobile } = useResponsiveLayout()

  return (
    <Column alignCenter fullWidth maxWidth="1150px">
      <AppearingWrapper centered kind="expand">
        <SubsectionTitle
          centered
          paragraph="Our Emajin network covers over 77+ industries in our community and growing"
          subtitle={
            <>
              Our members are closing over $2M+ in deals each month by
              leveraging our&nbsp;
              <br />
              <Text
                as="span"
                bold
                nowrap
                screen24={isMobile}
                screen28={!isMobile}
                success
              >
                Custom Connection System&trade;
              </Text>
              {isMobile ? <br /> : ' '}
              to build strong connections on the course.
            </>
          }
          title="Are you ready to harness the power of golf for business?"
        />
      </AppearingWrapper>
    </Column>
  )
}

export default MoreThanJustGolfSectionTitle
